import ReactVirtualizedAutoSizer from 'react-virtualized-auto-sizer';
import { Badge, Button, Grid, Group, Menu, ScrollArea, Tabs, Text, Title } from '@mantine/core';
import { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { useForm } from '@mantine/form';
import { Crumbline } from '../../../../core/components';

import { logger } from 'utils/logger';
import { getStatusColor, useEffectOnce } from 'utils/helper';
import { clearNotifications, fetchTalent, getTalentAssetsSuccess, getTalentSuccess, setDisplayPrefs, updateTalent } from 'modules/Talent/talentSlice';
import { selectTalent } from '../../talentSlice';
import { SHELL_TAB_BAR_HEIGHT } from 'utils/constants';
import { ListViewOption } from 'core/components/listToggle/listToggleControl';
import { closeAllModals, openModal } from '@mantine/modals';
import { IconChevronDown } from '@tabler/icons-react';
import { SampleEventType } from 'core/models/SampleModel';
import TalentTabGeneral from './TalentTabGeneral';
import { TalentModel } from 'core/models';
import { CaptureFilterModel } from 'core/models/CaptureFilterModel';
import { createStyles } from '@mantine/emotion';
// import Distribution from '../distribution/Distribution';

const useStyles = createStyles((theme) => ({
    tab: {
        // marginLeft:`-${theme.spacing.lg}px`,
        // marginRight:`-${theme.spacing.lg}px`
    },
    col: {
        padding: 0,
        flexGrow: 1,
        height: '100%',
        borderRight: `1px solid ${theme.colors.gray[2]}`,
        borderColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[2],
    },
    tabContent: {
        // padding: theme.spacing.xs,
        paddingTop: 0,
        height: '100%',
    },
}));

const Talent = ({ user, talent, guides, displayPrefs, success, error }) => {
    const dispatch = useDispatch();
    const { classes } = useStyles();
    const params = useParams();
    const [activeTab, setActiveTab] = useState('general');
    const [mediaFilter, setMediaFilter] = useState(new CaptureFilterModel());
    // const [scanFilter, setScanFilter] = useState(new ScanFilterModel());
    const [searchParams, setSearchParams] = useSearchParams();
    const [listView, setListView] = useState(ListViewOption.LIST);
    const [guideDataSet, setGuideDataSet] = useState(false);
    const navigate = useNavigate();

    // get the sample from the url
    useEffectOnce(() => {
        if (params && params.id) {
            logger.log(params);
            dispatch(clearNotifications());
            dispatch(fetchTalent(params.id));
            // dispatch(fetchTalentAssets(params.id,{}))
            // dispatch(fetchGuides({}));
            // dispatch(fetchTalentScans(params.id));
        }
    }, []);

    useEffect(() => {
        if (!success) return;

        switch (success.type) {
            case getTalentSuccess.toString(): {
                // fetch the assets.
                if (!talent) {
                    openModal({
                        title: 'Talent not found',
                        children: (
                            <>
                                <Text size='sm'>This talent doesn't exist make sure your talent code is correct</Text>
                                <Group position='right' mt={'sm'}>
                                    <Button
                                        mt='md'
                                        onClick={() => {
                                            closeAllModals();
                                            navigate(-1);
                                        }}>
                                        Go Back
                                    </Button>
                                </Group>
                            </>
                        ),
                    });
                }
                break;
            }
            case getTalentAssetsSuccess.toString(): {
                // fetch the assets.
                setGuideDataSet(false);
                // dispatch(clearNotifications())
                break;
            }
            default: {
                break;
            }
        }
    }, [success]);

    const form = useForm({
        initialValues: {
            first:'',
            last:'',
            talentNumber: '',
            photoCode: '',
            completed: '',
            sampleId: '',
            agency:'',
            gender:'',
            status:'',

        },

        // validate: {
        //   email: (value) => (/^\S+@\S+$/.test(value) ? null : 'Invalid email'),
        // },
    });

    useEffect(() => {
        form.setValues({ ...talent });

        logger.log(talent);
        // fetch the talent guides.
    }, [talent]);

    useEffect(() => {
        var newData = [];
        if (talent && talent.assets && guides && guides.length && !guideDataSet) {
            // grab the guides and categories for the assets
            newData = talent.assets.map((val) => {
                let talent = { ...val };
                if (val.guideID && guides) {
                    talent.guide = guides.find((guide) => guide.id === val.guideID);
                    if (talent.guide && talent.guide.guideCategories) {
                        talent.guideCategory = talent.guide.guideCategories.find((cat) => cat.id === talent.catId);
                    }
                }

                return talent;
            });
            setGuideDataSet(true);
            dispatch(selectTalent({ ...talent, assets: newData }));
        }

        // filterSamples();
    }, [talent, guides, dispatch]);

    const onTabChange = (val) => {
        var params = Object.fromEntries([...searchParams]);
        params.tab = val;
        setSearchParams(params);
    };

    /**
     * Effect to handle location change
     */
    useEffect(() => {
        // const params = new URLSearchParams(location.search);
        const currentParams = Object.fromEntries([...searchParams]);
        // let displayType = params.get('displayType');
        let displayType = currentParams.displayType;

        logger.log('location change ', currentParams, ' DISPLAY: ', displayType, params);
        // if display type changes
        if (displayType && displayType !== listView) {
            displayType = displayType === ListViewOption.LIST ? ListViewOption.LIST : displayType;
            // setListView(displayType);
            const prefs = { ...displayPrefs, mediaDisplayType: displayType };
            dispatch(setDisplayPrefs(prefs));
        }

        if (currentParams.tab) {
            setActiveTab(currentParams.tab);
        }
    }, [searchParams, listView]);

    // useEffect(() => {
    //     const currentParams = Object.fromEntries([...searchParams]);
    //     if (currentParams.tab) {
    //         setActiveTab(currentParams.tab);
    //     }
    // }, [searchParams, dispatch, setSearchParams]);

    // const containerTalent = { width:'1000px', marginTop:'20%', paddingLeft:'20%'}

    const onTalentAction = (event, data) => {
        switch (event.type) {
            case SampleEventType.SAMPLE_DISTRIBUTE: {
                openModal({
                    title: 'New Distribution (1)',
                    size: '80%',
                    children: <>{/* <Distribution selectedItems={[talent]} /> */}</>,
                });
                break;
            }
            default: {
                break;
            }
        }
    };

    const onFormSubmit = (vals) => {
        logger.log('Submitting form');

        const data = new TalentModel({...vals,files:vals.files,assetFiles:vals.assetFiles});
        dispatch(updateTalent(data,user));
    };

    return (
        <div
            style={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
            }}>
            <Group
                className='main-container-header'
                sx={(theme) => ({
                    width: '100%',
                    top: '0 !important',
                    borderBottom: `1px solid ${theme.colors.gray[3]}`,
                    borderColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[2],
                    backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.white,
                })}>
                <Group px='lg' position='apart' sx={{ width: '100%' }}>
                    <Crumbline></Crumbline>
                    {/* <Button>Create Sample</Button> */}
                </Group>
            </Group>
            <Group pt={'lg'} px={'lg'} position='apart'>
                <Group>
                    <Title order={3}>{talent?.fullName}</Title>
                    <Badge color={getStatusColor(talent?.status)}>{talent?.status}</Badge>
                </Group>

                <Menu position='bottom-end'>
                    <Menu.Target>
                        <Button variant='outline' rightIcon={<IconChevronDown size={14} />}>
                            Actions
                        </Button>
                    </Menu.Target>

                    <Menu.Dropdown>
                        {/* <Menu.Item onClick={() => onTalentAction({ type: SampleEventType.SAMPLE_DISTRIBUTE })} icon={<IconRocket size={14} />}>
                            Distribute
                        </Menu.Item> */}
                    </Menu.Dropdown>
                </Menu>
            </Group>

            <Grid mb='lg' style={{ margin: 0, height: 'auto', flexGrow: 1 }}>
                <Grid.Col span={12} className={`${classes.col} body-panels`} sx={{ height: '100%' }}>
                    <div style={{ height: '100%' }}>
                        <ReactVirtualizedAutoSizer disableWidth>
                            {({ height, width }) => {
                                return (
                                    <Tabs
                                        value={activeTab}
                                        sx={(theme) => ({
                                            borderRight: `1px solid ${theme.colors.gray[2]}`,
                                            '.mantine-Tabs-tabsList': {
                                                paddingLeft: theme.spacing.lg,
                                                paddingRight: theme.spacing.lg,
                                                paddingTop: 29,
                                            },
                                            borderColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[2],
                                        })}
                                        onTabChange={(e) => onTabChange(e)}>
                                        <Tabs.List>
                                            <Tabs.Tab value='general'>General</Tabs.Tab>
                                            <Tabs.Tab value='media'>Assets</Tabs.Tab>
                                            {/*<Tabs.Tab value='scans'>Scans</Tabs.Tab> */}
                                            {/* <Tabs.Tab value="activity">Activity</Tabs.Tab> */}
                                        </Tabs.List>

                                        <Tabs.Panel value='general'>
                                        <div className={classes.tabContent}>
                                                <ScrollArea
                                                    style={{
                                                        height: height - SHELL_TAB_BAR_HEIGHT,
                                                    }}>
                                            
                                                <TalentTabGeneral success={success} onFormSubmit={onFormSubmit} form={form} talent={talent} />
                                                </ScrollArea>
                                            </div>
                                        </Tabs.Panel>

                                        <Tabs.Panel value='media' className={classes.shellTabPanel}>
                                            <div
                                                className={`${classes.tabContent}`}
                                                style={{
                                                    height: height - SHELL_TAB_BAR_HEIGHT,
                                                }}>
                                                {/* <TalentTabMedia
                                                    form={form}
                                                    // onMediaAction={onMediaAction}
                                                    mediaFilter={mediaFilter}
                                                    setMediaFilter={setMediaFilter}
                                                /> */}
                                            </div>
                                        </Tabs.Panel>

                                        <Tabs.Panel value='scans' className={classes.shellTabPanel}>
                                            <div
                                                className={`${classes.tabContent}`}
                                                style={{
                                                    height: height - SHELL_TAB_BAR_HEIGHT,
                                                }}>
                                                {/* <TalentTabScans
                          form={form}
                          // onMediaAction={onMediaAction}
                          scanFilter={scanFilter}
                          setMediaFilter={setScanFilter}
                        /> */}
                                            </div>
                                        </Tabs.Panel>
                                    </Tabs>
                                );
                            }}
                        </ReactVirtualizedAutoSizer>
                    </div>
                </Grid.Col>
            </Grid>
        </div>
    );
};

const mapStateToProps = (state, props) => {
    //logger.log(state,props, ' mapstate')
    return {
        user: state.auth.user,
        talent: state.talentReducer.selectedTalent,
        success: state.talentReducer.success,
        displayPrefs: state.talentReducer.displayPrefs,
        error: state.talentReducer.error,
    };
};

const mapDispatch = { selectTalent };

export default connect(mapStateToProps, mapDispatch)(Talent);
